import { FC, JSX } from "react";
import { Box, Container, Flex, Grid } from "@radix-ui/themes";
import { AuthLayoutProps } from "./AuthLayout.types";

const AuthLayout: FC<AuthLayoutProps> = ({ children }): JSX.Element => {
  return (
    <Flex direction="column" minHeight="100vh" justify="center">
      <Box>
        <Container px={{ initial: "4", lg: "0" }}>
          <Grid columns={{ initial: "1", lg: "2" }} gap="9">
            {children}
          </Grid>
        </Container>
      </Box>
    </Flex>
  );
};

export default AuthLayout;
